import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { useCallback } from 'react';
import { useCookies } from 'react-cookie';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { EVENT_CTA_CLICK, trackEvent } from '../../../../../utils/tracker';

export const Button = ({ title: rawTitle = 'Personalize my rotation', position }) => {
  const [{ checkout }] = useCookies(['checkout']);
  const answers = useSelector(({ quiz }) => quiz.customRotation);
  const isUnfinishedQuiz = useMemo(() => Object.keys(answers).length > 0, [answers]);
  const [onScreen, setOnScreen] = useState(false);

  useEffect(() => {
    setTimeout(() => setOnScreen(true), 0);
  }, [onScreen]);

  const title = useMemo(() => (checkout || isUnfinishedQuiz ? 'Finish Checkout' : rawTitle), [
    rawTitle,
    checkout,
    isUnfinishedQuiz,
  ]);

  const onClick = useCallback(() => {
    trackEvent(EVENT_CTA_CLICK, { position });

    if (checkout) {
      window.location.href = `/get_started/${checkout}`;
      return;
    }

    if (isUnfinishedQuiz) {
      window.location.href = '/filter_checkout?finished=true';
      return;
    }

    window.location.href = '/filter_checkout';
  }, [position, checkout, isUnfinishedQuiz]);

  return (
    <>
      <button
        className={classNames('btn btn-accent btn-lg cta-services fade-on-screen fade-delay-1', {
          'on-screen': onScreen,
        })}
        onClick={onClick}
      >
        {title}
      </button>
      <a
        href="/public_shop"
        className={classNames('btn btn-outline-white btn-lg d-flex align-items-center fade-on-screen fade-delay-2', {
          'on-screen': onScreen,
        })}
      >
        Shop coffee
      </a>
    </>
  );
};

Button.propTypes = {
  title: PropTypes.string,
  position: PropTypes.string,
};
